import { IonButton, IonButtons, IonContent, IonHeader, IonInput, IonItem, IonList, IonModal, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/react";
import React from "react";
import { DeviceInputGroup, DeviceServiceOutput } from "../service/API";

export default class OutputServiceModal extends React.Component<{inputGroups ? : DeviceInputGroup[], editOutputService ? : DeviceServiceOutput, onClose: (result: boolean) => void}, any> {

    handleChangeGroupValue = (group: any, key: string) => (ev: any) => {
        if (ev.detail.checked !== undefined) {
            group[key] = ev.detail.checked;

        } else {
            group[key] = ev.detail.value;
        }
        this.setState({});
    }

    handleClose = (result: boolean) => {
        this.props.onClose(result);
    }
    render() {
        const { editOutputService } = this.props;

        return <IonModal isOpen={this.props.editOutputService! ? true : false}
            onDidDismiss={() => this.handleClose(false)}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Nuevo Servicio Externo</IonTitle>
                    <IonButtons slot={"secondary"}>
                        <IonButton onClick={() => this.handleClose(false)}>Cancelar</IonButton>
                    </IonButtons>
                    <IonButtons slot={"primary"}>
                        <IonButton onClick={() => this.handleClose(true)}>OK</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                {editOutputService && <IonList>

                    <IonItem>
                        <IonInput label="Título" value={editOutputService.title} onIonInput={this.handleChangeGroupValue(editOutputService, 'title')}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonSelect label="Tipo Principal (lora)" value={editOutputService.name} onIonChange={this.handleChangeGroupValue(editOutputService, 'name')}>
                            <IonSelectOption value={'lora'}>Estaciones Lora TTN (lora)</IonSelectOption>
                            <IonSelectOption value={'contador'}>Panel de Contador SF100</IonSelectOption>
                            <IonSelectOption value={'modbus-lora'}>FS WiFi - Modbus</IonSelectOption>
                            <IonSelectOption value={'LoraFS_MQTT'}>FS WiFi - MQTT</IonSelectOption>
                        </IonSelect>
                    </IonItem>
                    <IonItem hidden={editOutputService.name !== 'lora'}>
                        <IonSelect label="Tipo" value={editOutputService.service_type} onIonChange={this.handleChangeGroupValue(editOutputService, 'service_type')}>
                            <IonSelectOption value={'FieldStation2'}>FieldStation2</IonSelectOption>
                            <IonSelectOption value={'SenseCAP'}>SenseCAP</IonSelectOption>
                            {/* <IonSelectOption value={'FieldStationWifi'}>FieldStationWifi</IonSelectOption> */}
                        </IonSelect>
                    </IonItem>
                    <IonItem hidden={editOutputService.name !== 'lora'}>
                        <IonInput label="Ajustes" value={editOutputService.settings} placeholder="TTN Device ID" onIonInput={this.handleChangeGroupValue(editOutputService, 'settings')}></IonInput>
                    </IonItem>
                    <IonItem hidden={editOutputService.name !== 'LoraFS_MQTT'}>
                        <IonInput label="Ajustes" value={editOutputService.settings} placeholder="FS Unit ID" onIonInput={this.handleChangeGroupValue(editOutputService, 'settings')}></IonInput>
                    </IonItem>
                    <IonItem hidden={editOutputService.name !== 'LoraFS_MQTT'}>
                        <IonInput label="ID Estacion (1-16)" value={editOutputService.datr} placeholder="ID Estacion (1-16)" onIonInput={this.handleChangeGroupValue(editOutputService, 'datr')}></IonInput>
                    </IonItem>
                    
                    <IonItem>
                        <IonSelect label="Entrada Asociada" value={editOutputService.input_group} onIonChange={this.handleChangeGroupValue(editOutputService, 'input_group')} >
                            {this.props.inputGroups && this.props.inputGroups.map((v: any, k: any) => {
                                return <IonSelectOption key={k} value={v.iindex}>{v.name}</IonSelectOption>
                            })}
                        </IonSelect>
                    </IonItem>
                    <IonItem hidden={editOutputService.name !== 'lora'}>
                        <IonInput label="Frecuencia (MHz)" type="number" value={editOutputService.freq} onIonInput={this.handleChangeGroupValue(editOutputService, 'freq')}></IonInput>
                    </IonItem>
                    <IonItem hidden={editOutputService.name !== 'lora'}>
                        <IonSelect label="Data Rate" value={editOutputService.datr} onIonChange={this.handleChangeGroupValue(editOutputService, 'datr')} >
                            <IonSelectOption value={"SF7BW125"}>SF7BW125</IonSelectOption>
                            <IonSelectOption value={"SF8BW125"}>SF8BW125</IonSelectOption>
                            <IonSelectOption value={"SF9BW125"}>SF9BW125</IonSelectOption>
                            <IonSelectOption value={"SF10BW125"}>SF10BW125</IonSelectOption>
                            <IonSelectOption value={"SF11BW125"}>SF11BW125</IonSelectOption>
                            <IonSelectOption value={"SF12BW125"}>SF12BW125</IonSelectOption>
                            <IonSelectOption value={"SF7BW250"}>SF7BW250</IonSelectOption>
                            <IonSelectOption value={"SF8BW250"}>SF8BW250</IonSelectOption>
                            <IonSelectOption value={"SF9BW250"}>SF9BW250</IonSelectOption>
                            <IonSelectOption value={"SF10BW250"}>SF10BW250</IonSelectOption>
                            <IonSelectOption value={"SF11BW250"}>SF11BW250</IonSelectOption>
                            <IonSelectOption value={"SF12BW250"}>SF12BW250</IonSelectOption>
                            
                        </IonSelect>
                    </IonItem>
                    <IonItem hidden={editOutputService.name !== 'lora'}>
                        <IonSelect label="Code Rate" value={editOutputService.codr} onIonChange={this.handleChangeGroupValue(editOutputService, 'codr')} >
                            <IonSelectOption value={"4/5"}>4/5</IonSelectOption>
                            <IonSelectOption value={"4/6"}>4/6</IonSelectOption>
                            <IonSelectOption value={"4/7"}>4/7</IonSelectOption>
                            <IonSelectOption value={"4/8"}>4/8</IonSelectOption>                            
                        </IonSelect>
                    </IonItem>
                </IonList>}
            </IonContent>

        </IonModal>
    }
}